import { HElement, HElements, HFnc, HObj, HTagAttrs, HTagChildren, HTagHead } from "./hsml";

export function h<ActionType extends string>(tag: HTagHead): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, children: HTagChildren<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, text: string | String | boolean | Boolean | number | Number | Date | null): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, hfnc: HFnc): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, hobj: HObj<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, helement: HElement<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, helements: HElements<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>, children: HTagChildren<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>, text: string | String | boolean | Boolean | number | Number | Date | null): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>, hfnc: HFnc): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>, hobj: HObj<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>, helement: HElement<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(tag: HTagHead, attrs: HTagAttrs<ActionType>, helements: HElements<ActionType>): HElement<ActionType>;
export function h<ActionType extends string>(
    tag: HTagHead,
    second?: HTagAttrs<ActionType> | HTagChildren<ActionType> | HElement<ActionType>,
    third?: HTagAttrs<ActionType> | HTagChildren<ActionType> | HElement<ActionType>): HElement<ActionType> {
    switch (arguments.length) {
        case 1:
            return [tag] as HElement<ActionType>;
        case 2:
            if (isHElement(second)) {
                // HElement - wrap in children array
                return [tag, [second]] as HElement<ActionType>;
            } else {
                return [tag, second] as HElement<ActionType>;
            }
        case 3:
        default:
            if (isHElement(third)) {
                // HElement - wrap in children array
                return [tag, second, [third]] as HElement<ActionType>;
            } else {
                return [tag, second, third] as HElement<ActionType>;
            }
    }
}

function isHElement(arg: any): boolean {
    return Array.isArray(arg) && arg.length > 0 && typeof arg[0] === "string";
}
